import React from "react";
import { Box, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

function TextQuestion() {
  return (
    <Box>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        <FormattedMessage id="survey.text_question.message" />
      </Typography>
    </Box>
  );
}

export default TextQuestion;